<template>
    <tabset ref="tabs" :keytabset="'profile'" :rememberTab="isMyOwnProfile">
        <tab :header="viajesHeaderTitle">
            <component :is="currentView" :userId="id"></component>
        </tab>
        <tab :header="$t('perfil')">
            <ProfileInfo></ProfileInfo>
        </tab>
        <tab :header="$t('calificaciones')">
            <ProfileRates :id="id"></ProfileRates>
        </tab>
        <!-- Onglet de vérification du téléphone -->
        <tab 
            v-if="isMyOwnProfile && smsRequired && !user.phone_verified_at" 
            :header="$t('verificacionTelefono')"
        >
            <SmsIdentityValidation 
                @verified="onPhoneVerified"
            />
        </tab>
    </tabset>
</template>
<script>
import Tab from '../elements/Tab';
import Tabset from '../elements/Tabset';
import { mapActions, mapGetters } from 'vuex';
import ProfileInfo from '../sections/ProfileInfo';
import ProfileRates from '../sections/ProfileRates';
import MyTrips from './MyTrips';
import ProfileTrip from '../sections/ProfileTrip';
import SmsIdentityValidation from '../sections/SmsIdentityValidation.vue';
import dialogs from '../../services/dialogs.js';
import bus from '../../services/bus-event.js';
import router from '../../router';

export default {
    components: {
        Tab,
        Tabset,
        ProfileInfo,
        ProfileRates,
        MyTrips,
        ProfileTrip,
        SmsIdentityValidation
    },

    props: {
        id: {
            required: false,
            default: 'me'
        },
        userProfile: {
            required: false
        },
        activeTab: {
            required: false
        }
    },

    data() {
        return {
            currentView: null
        };
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
            profile: 'profile/user',
            config: 'auth/appConfig'
        }),
        viajesHeaderTitle() {
            return this.id === 'me' || this.id === this.user.id
                ? this.$t('misViajes')
                : this.$t('viajes');
        },
        isMyOwnProfile() {
            return this.id === 'me' || this.id === this.user.id;
        },
        smsRequired() {
            return this.config && 
                   this.config.identity_validation_sms_enabled;
        }
    },

    methods: {
        ...mapActions({
            setTitle: 'actionbars/setTitle',
            setProfile: 'profile/setUser',
            setProfileByID: 'profile/setUserByID',
            fetchBadges: 'profile/fetchBadges'
        }),
        updateProfile() {
            if (this.id === 'me' || this.id === this.user.id) {
                // this.setTitle('Mi Perfil');
                this.setProfile(this.user);
                this.fetchBadges(this.user ? this.user.id : 'me');
                this.currentView = 'my-trips';
            } else {
                if (this.userProfile) {
                    this.setTitle(this.userProfile.name);
                }
                this.setProfileByID({
                    id: this.id,
                    userProfile: this.userProfile
                })
                    .then(() => {
                        this.setTitle(this.profile.name);
                        this.fetchBadges(this.id);
                    })
                    .catch(() => {
                        this.$router.replace({ name: 'trips' });
                    });
                this.currentView = 'profile-trip';
            }
        },
        onPhoneVerified() {
            console.log('✅ [Profile] Phone verified! Refreshing user data...');
            // Afficher le message de succ\u00e8s
            dialogs.message(this.$t('telefonoYaVerificado'), { 
                duration: 4, 
                position: 'top-center', 
                estado: 'success' 
            });
            
            // Recharger la page pour que l'onglet disparaisse
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        },
        onBackClick() {
            router.back();
        }
    },
    watch: {
        $route: function () {
            this.updateProfile();
        }
    },

    mounted() {
        let index = 1;
        if (
            router.history &&
            router.history.current &&
            router.history.current.hash
        ) {
            index = parseInt(router.history.current.hash.replace('#', ''), 10);
        }
        if (this.activeTab) {
            index = parseInt(this.activeTab, 10);
        } else {
            index = this.$refs.tabs.getRememberedTab(1);
        }
        
        // Activer l'onglet
        this.$refs.tabs.activateTab(index);
        this.updateProfile();
        bus.on('back-click', this.onBackClick);
        
        // Debug: Afficher les valeurs pour l'onglet de vérification SMS
        console.log('📱 [Profile] SMS Verification Tab Debug:');
        console.log('  - isMyOwnProfile:', this.isMyOwnProfile);
        console.log('  - smsRequired (config):', this.smsRequired);
        console.log('  - config object:', this.config);
        console.log('  - user.phone_verified_at:', this.user ? this.user.phone_verified_at : 'user not loaded');
        console.log('  - Should show tab:', this.isMyOwnProfile && this.smsRequired && !(this.user && this.user.phone_verified_at));
        console.log('  - Active tab index:', index);
    },
    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    }
};
</script>
